/**
 * AYP年上年下恋爱倾向测试 - 人格类型数据
 * 
 * 包含两大类人格分析:
 * 1. 年上年下恋爱人格类型 (5种)
 * 2. 依恋类型人格 (4种)
 */

// 年上年下恋爱人格类型
export const RELATIONSHIP_PERSONALITY_TYPES = {
  "年上恋人型": {
    scoreRange: [81, 100],
    emoji: "🧓",
    bigEmoji: "🧓",
    summary: "年上倾向恋人",
    description: "你倾向于寻找比自己年长的伴侣,享受被照顾和引导的感觉,在关系中更愿意扮演被保护的角色。",
    features: [
      "喜欢被年长伴侣照顾和指导",
      "享受被保护和被宠爱的感觉",
      "在关系中更愿意扮演依赖者的角色",
      "重视伴侣的成熟度和经验",
      "倾向于寻找能提供安全感和稳定性的伴侣",
      "欣赏年长者的智慧和人生阅历"
    ],
    psychology: "根据心理学研究,年上恋人型个体通常具有较高的依赖需求,倾向于寻找能提供安全感和稳定性的伴侣。这种倾向可能与童年期的依恋模式有关,研究表明这类个体往往在关系中寻求情感上的指导和支持。",
    advice: [
      "寻找能够提供稳定性和安全感的年长伴侣",
      "学习在依赖和独立之间找到平衡点",
      "培养自己的独立性,避免过度依赖伴侣",
      "寻找能够尊重你成长空间的伴侣",
      "与伴侣建立清晰的沟通模式,表达你的情感需求",
      "保持个人兴趣爱好,确保在关系中有足够的自我空间"
    ]
  },
  "成熟偏好型": {
    scoreRange: [61, 80],
    emoji: "👨‍🏫",
    bigEmoji: "👨‍🏫",
    summary: "成熟偏好恋人",
    description: "你重视伴侣的成熟度和稳定性,倾向于选择能够提供安全感和指导的伴侣,但也能保持一定的独立性。",
    features: [
      "重视伴侣的成熟度和人生经验",
      "喜欢被引导但也能保持独立",
      "在关系中寻求安全感和稳定性",
      "能够平衡依赖和自主的需求",
      "欣赏有责任感和可靠性的伴侣",
      "重视长期关系的稳定发展"
    ],
    psychology: "成熟偏好型个体通常具有适度的依赖需求,倾向于寻找能够提供安全感和指导但不过度控制的伴侣。研究表明,这类个体往往在关系中寻求情感安全的同时,也重视个人的独立性和自主权。",
    advice: [
      "寻找能够提供指导但尊重你独立性的伴侣",
      "培养自己的决策能力,减少对伴侣的过度依赖",
      "学习在关系中表达自己的需求和界限",
      "寻找能够共同成长和学习的伴侣",
      "建立健康的依赖模式,避免过度独立或过度依赖",
      "重视伴侣的情绪稳定性和责任感"
    ]
  },
  "平衡型": {
    scoreRange: [41, 60],
    emoji: "⚖️",
    bigEmoji: "⚖️",
    summary: "平衡型恋人",
    description: "你在恋爱关系中保持平衡,既能够享受被照顾的感觉,也能够照顾伴侣,年龄差距对你来说不是关键因素。",
    features: [
      "能够在依赖和独立之间找到平衡",
      "既享受被照顾也乐于照顾他人",
      "年龄差距不是选择伴侣的关键因素",
      "重视关系的平等和相互支持",
      "能够根据情境调整自己在关系中的角色",
      "重视伴侣的性格特质而非年龄"
    ],
    psychology: "平衡型个体通常具有健康的关系模式,能够在亲密和独立之间找到平衡,建立相互支持的关系。心理学研究表明,这类个体往往具有较高的情感调节能力和关系适应能力,能够在不同情境下灵活调整自己的角色。",
    advice: [
      "寻找能够相互支持和理解的伴侣",
      "继续维持关系中的平衡和相互尊重",
      "关注伴侣的情感需求,建立深度连接",
      "培养共同兴趣爱好,增强关系纽带",
      "保持开放沟通,及时调整关系中的不平衡",
      "重视伴侣的性格特质和价值观匹配度"
    ]
  },
  "活力偏好型": {
    scoreRange: [21, 40],
    emoji: "🎭",
    bigEmoji: "🎭",
    summary: "活力偏好恋人",
    description: "你重视伴侣的活力和新鲜感,倾向于选择能够带来刺激和变化的伴侣,但也能提供适当的照顾和指导。",
    features: [
      "重视伴侣的活力和创造力",
      "喜欢引导但也能接受被引导",
      "在关系中寻求新鲜感和刺激",
      "能够提供照顾但也重视个人空间",
      "欣赏有冒险精神和开放心态的伴侣",
      "重视关系中的乐趣和共同成长"
    ],
    psychology: "活力偏好型个体通常具有较高的活力和创造力,倾向于寻找能够带来新鲜感和刺激的伴侣。心理学研究表明,这类个体往往具有较高的开放性和外向性,喜欢在关系中探索新的可能性和体验。",
    advice: [
      "寻找能够带来活力和新鲜感的伴侣",
      "学习在引导和跟随之间灵活转换",
      "保持个人空间的独立性",
      "寻找能够欣赏你创造力和活力的伴侣",
      "建立充满乐趣和探索的关系模式",
      "平衡关系中的稳定性和新鲜感"
    ]
  },
  "年下恋人型": {
    scoreRange: [0, 20],
    emoji: "🧒",
    bigEmoji: "🧒",
    summary: "年下倾向恋人",
    description: "你倾向于寻找比自己年轻的伴侣,享受引导和照顾对方的感觉,在关系中更愿意扮演保护者的角色。",
    features: [
      "喜欢照顾和引导年轻伴侣",
      "享受被依赖和被需要的感觉",
      "在关系中更愿意扮演保护者的角色",
      "重视伴侣的活力和新鲜感",
      "倾向于在关系中承担更多责任",
      "欣赏年轻伴侣的创造力和活力"
    ],
    psychology: "年下恋人型个体通常具有较高的照顾欲望和领导倾向,倾向于在关系中扮演指导者和保护者的角色。心理学研究表明,这类个体往往具有较高的责任感和自我效能感,喜欢在关系中发挥主导作用。",
    advice: [
      "寻找能够欣赏你成熟和经验的年轻伴侣",
      "学习给予伴侣适当的自由和成长空间",
      "避免过度控制,尊重伴侣的独立性",
      "寻找能够激发你活力和创造力的伴侣",
      "与伴侣建立平等的沟通模式,避免单向指导",
      "保持开放心态,学习从年轻伴侣身上获取新视角"
    ]
  }
};

// 依恋类型人格
export const ATTACHMENT_TYPES = {
  "安全-自主平衡型": {
    emoji: "⚖️",
    bigEmoji: "⚖️",
    summary: "安全-自主平衡型",
    color: "#4CAF50",
    description: "你属于'安全-自主平衡型依恋',既需要感情中的'稳定感',也不希望失去'新鲜感'。你能接受伴侣的成熟照顾,也享受和伴侣一起探索未知;可以理性讨论未来,也能放下顾虑享受当下。你的适配关键不在于'年龄',而在于'伴侣的性格特质是否能匹配你的动态需求'。",
    features: [
      "能在稳定和新鲜感之间找到平衡",
      "既能接受照顾也能保持独立自主",
      "理性与感性并重,能够灵活适应关系变化",
      "重视关系中的平等和相互成长",
      "能够建立健康的情感边界",
      "在关系中保持适度的依赖和独立"
    ],
    psychology: "安全-自主平衡型是健康的依恋模式,研究表明这类个体在关系中体验更高的满意度和幸福感,能够建立持久而富有活力的亲密关系。这类个体通常具有较高的情绪调节能力和关系适应能力,能够在不同情境下保持关系的平衡和健康。",
    advice: [
      "寻找能够平衡稳定与新鲜感的伴侣",
      "保持自主性,同时享受关系的亲密感",
      "在关系中保持开放心态,尝试新的相处方式",
      "与伴侣共同制定关系目标,确保双方需求得到满足",
      "建立清晰的沟通模式,及时表达情感需求",
      "保持个人空间,同时培养共享的兴趣爱好"
    ]
  },
  "探索-依赖型": {
    emoji: "🌊",
    bigEmoji: "🌊",
    summary: "探索-依赖型",
    color: "#FF3366",
    description: "你渴望关系中的新鲜感和探索乐趣,同时也需要情感上的依赖和支持。你享受与伴侣一起发现新事物,但也需要确定感来获得安全感。在关系中,你既能扮演探索者的角色,也愿意在需要时依赖伴侣。",
    features: [
      "渴望关系中的新鲜感和探索乐趣",
      "需要情感依赖但同时保持一定的独立性",
      "享受与伴侣共同成长和学习的过程",
      "在稳定和变化之间寻求平衡",
      "能够适应关系中的动态变化",
      "重视情感连接和共同体验"
    ],
    psychology: "探索-依赖型结合了对新鲜感的追求和情感依赖的需求,这类个体通常具有较高的适应性和创造力,能够在关系中保持活力和深度。研究表明,这类个体往往在关系中寻求情感安全的同时,也重视个人的成长和探索。",
    advice: [
      "寻找能够陪你探索世界同时也提供情感支持的伴侣",
      "学习在依赖和独立之间找到个人舒适区",
      "与伴侣分享你的探索欲望和情感需求",
      "建立关系仪式感,平衡新鲜感和稳定性",
      "保持开放的沟通,及时调整关系中的不平衡",
      "培养共同兴趣爱好,增强关系纽带"
    ]
  },
  "独立-回避型": {
    emoji: "🏔️",
    bigEmoji: "🏔️",
    summary: "独立-回避型",
    color: "#2196F3",
    description: "你高度重视个人空间和独立性,在关系中需要足够的自由度。你能够自我满足,不依赖他人来获得幸福感,但也能够建立有意义的连接。在关系中,你更倾向于平等相处,避免过度依赖或控制。",
    features: [
      "高度重视个人空间和独立性",
      "能够自我满足,不依赖他人获得幸福感",
      "在关系中需要足够的自由和自主权",
      "能够建立有深度但不过度依赖的关系",
      "重视平等和相互尊重的相处模式",
      "能够清晰表达个人边界和需求"
    ],
    psychology: "独立-回避型个体通常具有较高的自我价值感和内在安全感,能够建立健康的关系边界,避免过度依赖或控制。研究表明,这类个体往往在关系中保持适度的情感距离,同时能够建立深度和有意义的连接。",
    advice: [
      "寻找尊重你独立性的伴侣",
      "学习在保持独立的同时表达情感需求",
      "与伴侣沟通你对个人空间的需求",
      "建立清晰的关系边界,确保双方舒适",
      "培养共享活动,增强情感连接",
      "保持适度的开放性,允许自己逐渐建立信任"
    ]
  },
  "矛盾-动态型": {
    emoji: "🌪️",
    bigEmoji: "🌪️",
    summary: "矛盾-动态型",
    color: "#9C27B0",
    description: "你在关系中表现出矛盾的倾向,既渴望亲密又需要空间,既想依赖又害怕失去自主权。你的需求会随着情境变化而动态调整,需要在关系中找到个性化的平衡点。",
    features: [
      "在亲密和独立之间表现出矛盾倾向",
      "需求会随着情境变化而动态调整",
      "既渴望深度连接又重视个人自由",
      "在关系中需要灵活的空间和界限",
      "情感需求较为复杂和多变",
      "能够适应不同关系模式的切换"
    ],
    psychology: "矛盾-动态型反映了复杂的情感需求模式,这类个体通常具有较高的情感敏感度和适应性,需要在关系中找到个性化的平衡点。研究表明,这类个体往往在关系中经历较多的情感波动,但同时也具有较强的适应能力和关系调整能力。",
    advice: [
      "寻找能够理解你动态需求的伴侣",
      "学习识别和表达你变化的情感需求",
      "与伴侣建立灵活的相处模式",
      "培养自我觉察,了解情感波动的规律",
      "建立清晰但可调整的关系边界",
      "寻找能够提供稳定基础同时尊重你变化的伴侣"
    ]
  }
};

/**
 * 根据AYP分数判定人格类型
 * @param {number} aypScore - AYP指数 (0-100)
 * @returns {string} 人格类型名称
 */
export function determinePersonalityType(aypScore) {
  if (aypScore >= 81) return '年上恋人型';
  if (aypScore >= 61) return '成熟偏好型';
  if (aypScore >= 41) return '平衡型';
  if (aypScore >= 21) return '活力偏好型';
  return '年下恋人型';
}

/**
 * 计算依恋类型分数
 * @param {Object} normalizedScores - 归一化后的四维度分数
 * @returns {Object} 四种依恋类型的分数
 */
export function calculateAttachmentScores(normalizedScores) {
  const { MAT, CAR, GUI, IND } = normalizedScores;
  
  return {
    '安全-自主平衡型': Math.max(0, 100 - Math.abs(50 - MAT) / 2),
    '探索-依赖型': (CAR + (100 - IND)) / 2,
    '独立-回避型': (IND + (100 - CAR)) / 2,
    '矛盾-动态型': (Math.abs(50 - MAT) + Math.abs(50 - GUI)) / 2
  };
}

/**
 * 判定主导和次要依恋类型
 * @param {Object} attachmentScores - 依恋类型分数
 * @returns {Object} { primary: 主导类型, secondary: 次要类型 }
 */
export function determineAttachmentType(attachmentScores) {
  const sorted = Object.entries(attachmentScores)
    .sort((a, b) => b[1] - a[1]);
  
  return {
    primary: sorted[0][0],
    secondary: sorted[1][0],
    scores: {
      primary: Math.round(sorted[0][1]),
      secondary: Math.round(sorted[1][1])
    }
  };
}

